export const SET_STARTING_PRODUCT = 'SET_STARTING_PRODUCT';

export const setStartingProduct = (payload) => ({
  type: SET_STARTING_PRODUCT,
  payload,
})